import React, { useState } from 'react'
import { useHistory } from "react-router-dom";
import CheckButton from '../../../../utils/components/CheckButton/CheckButton';
import TitleSVG from '../../../../utils/components/TitleSVG/TitleSVG';
import { ReturnIcon } from '../../../../assets/icons';
import { Table } from '../../../components/Table/Table';
import style from './TransferHistoryView.module.css'

const TransferHistoryView = ({ transfers, orderType, setOrderType }) => {
    const history = useHistory()
    return (
        <div>

            <TitleSVG Icon={ReturnIcon}
                titleHighlight={'Histórico'}
                title={' de transferencias'} />
            <div className={`content-admin flex-row-start margin-top-20`}>

                <div className={`admin-subtitle margin-right-20`}>Seleccione el tipo de transferencia</div>
                <div>
                    <CheckButton textName={"Transferencia"} option={"catering"} setValue={setOrderType} value={orderType} />
                    <CheckButton textName={"Compra"} option={"purchase"} setValue={setOrderType} value={orderType} />
                    <CheckButton textName={"Consignación"} option={"consignment"} setValue={setOrderType} value={orderType} />
                </div>
            </div>

            <div className={`margin-top-20 ${style.table_container}`}>
                <Table>
                    <thead>
                        <tr>
                            <th>Fecha</th>
                            <th>Tipo</th>
                            <th>Origen</th>
                            <th>Destino</th>
                            <th>ID Transferencia</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            transfers.map(transfer => (
                                <tr className='cursor-pointer' key={transfer._id} onClick={() => { history.push(`OrderDetaill/${transfer._id}`) }}>
                                    <td>{new Date(transfer.creationDate).toLocaleDateString()}</td>
                                    <td>
                                        {
                                            transfer.orderType ==='purchase' && "Compra"
                                        }
                                        {
                                            transfer.orderType ==='catering' && "Transferencia"
                                        }
                                        {
                                            transfer.orderType ==='consignment' && "Consignación"
                                        }
                                    </td>
                                    <td>{transfer.receivingWineryId.name}</td>
                                    <td>
                                        {
                                            transfer?.transmitterRepresentativeId && transfer?.transmitterRepresentativeId?.name
                                        }
                                        {
                                            transfer?.transmitterFranchiseId && transfer?.transmitterFranchiseId?.socialReason
                                        }
                                        {
                                            transfer?.transmitterUserId && `${transfer?.transmitterUserId?.name} ${transfer?.transmitterUserId?.lastname}`
                                        }
                                        {
                                            transfer?.transmitterWarehouseId && transfer?.transmitterWarehouseId?.name
                                        }
                                        {
                                            transfer?.transmitterSubwineryId && transfer?.transmitterSubwineryId?.name
                                        }

                                    </td>
                                    <td>{transfer.code}</td>
                                </tr>
                            ))
                        }
                    </tbody>
                </Table>
            </div>
        </div>
    )
}

export default TransferHistoryView
